import { InfoCard } from '@/components/info-card';
import { groupAvailabilitiesByDay } from '@/lib/coach-availability-utils';
import { formatPlainTime } from '@airreading/common';
import { CoachAvailability, DayOfWeek, teachingDays, DayOfWeekLabelMap } from '@airreading/common/data';

export interface TeachingAvailabilityCardProps {
  availabilities: CoachAvailability[];
  timeZone: string;
}

export function TeachingAvailabilityCard({ availabilities, timeZone }: TeachingAvailabilityCardProps) {
  const { availabilitiesByDay } = groupAvailabilitiesByDay(availabilities, timeZone);

  return (
    <InfoCard
      headerText={
        <div>
          Teaching availability
          <span className="text-lg font-normal"> ({timeZone})</span>
        </div>
      }
    >
      <div className="grid grid-cols-7 gap-4">
        {teachingDays.map((day: DayOfWeek) => {
          const dayAvailabilities = availabilitiesByDay.find((d) => d.day === day)?.availabilities ?? [];

          return (
            <div key={day}>
              <div className="font-semibold">{DayOfWeekLabelMap[day].abbr}</div>
              {dayAvailabilities.length === 0 ? (
                <div className="text-muted">-</div>
              ) : (
                dayAvailabilities.map((availability, index) => {
                  const start = formatPlainTime(availability.startPlainTime, { hour12: true });
                  const end = formatPlainTime(availability.endPlainTime, { hour12: true });
                  const isLast = index === dayAvailabilities.length - 1;
                  return <div key={`${day}-${index}`}>{`${start} - ${end}${isLast ? '' : ','}`}</div>;
                })
              )}
            </div>
          );
        })}
      </div>
    </InfoCard>
  );
}
